// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2b-do","toggle":"styles_toggle__3W1UR","preview":"styles_preview__dK0N4"};